export const DEMONSTRATION_ANIMATION_DURATION = "0.3s";

export const headerPadding = {
  top: {
    xl: "60px",
    md: "30px",
  },
  horizontal: {
    lg: "10%",
    sm: "5%",
  },
};
